<ion-button fill="clear" (click)="open($event)" tooltip="Get Help" aria-label="Help Menu">
  <ion-icon src="/assets/icons/24px/question.svg"> </ion-icon>
  <span>Help</span>
</ion-button>
